export default __webpack_public_path__ + "static/media/SIW200H_S057_75_114_W20.8c978a3c.webp";